export const sortNarratives = (a, b) => {
  const aEnabled = typeof a.enabled === 'undefined' || a.enabled;
  const bEnabled = typeof b.enabled === 'undefined' || b.enabled;

  if (!aEnabled && bEnabled) {
    return -1;
  }

  if (!bEnabled && aEnabled) {
    return 1;
  }

  if (a.progress === 100 && b.progress < 100) {
    return -1;
  }

  if (b.progress === 100 && a.progress < 100) {
    return 1;
  }

  if (a.section.section_position < b.section.section_position) {
    return -1;
  }

  if (b.section.section_position < a.section.section_position) {
    return 1;
  }

  if (a.position < b.position) {
    return -1;
  }

  if (b.position < a.position) {
    return 1;
  }

  if (a.progress > 0 && b.progress === 0) {
    return -1;
  }

  if (b.progress > 0 && a.progress === 0) {
    return 1;
  }

  return a.progress > b.progress;
};



// WEBPACK FOOTER //
// ./src/utils/serendipity.js